import React from 'react';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import VerifiedUserOutlined from '@mui/icons-material/VerifiedUserOutlined';
import Typography from '@mui/material/Typography';
import { Label } from '../Label';
export const SatisfyOrRefundLabel = ({ isUpperCase, }) => (React.createElement(Label, { icon: React.createElement(VerifiedUserOutlined, { fontSize: "small" }), backgroundColor: "green100", textColor: "green500", padding: "small" },
    React.createElement(Typography, { variant: 'caption', fontSize: '12px', fontWeight: 600, textTransform: isUpperCase ? 'uppercase' : 'none', sx: {
            wordSpacing: '-2px',
        } }, "\u2002Satisfait ou rembours\u00E9"),
    React.createElement(ArrowForwardIcon, { fontSize: "small" })));
